import React, {FC} from "react";

const CopyIcon: FC = () => {
  return (
      <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.0432 4.6416H2.95696C2.6369 4.6416 2.37744 4.87431 2.37744 5.16136V28.2966C2.37744 28.5837 2.6369 28.8164 2.95696 28.8164H21.0432C21.3633 28.8164 21.6227 28.5837 21.6227 28.2966V5.16136C21.6227 4.87431 21.3633 4.6416 21.0432 4.6416Z" fill="white" stroke="black" strokeWidth="2" strokeMiterlimit="10"/>
        <path d="M15.3826 2.4043H8.61711C8.29706 2.4043 8.0376 2.66375 8.0376 2.98381V6.29918C8.0376 6.61923 8.29706 6.87869 8.61711 6.87869H15.3826C15.7027 6.87869 15.9621 6.61923 15.9621 6.29918V2.98381C15.9621 2.66375 15.7027 2.4043 15.3826 2.4043Z" fill="white" stroke="black" strokeWidth="2" strokeMiterlimit="10"/>
      </svg>
  )
}

export default CopyIcon;